

























































import { mapGetters } from 'vuex';

export default {
    name: 'JobRequirementExperience',

    props: {
        experience: {
            required: true,
            type: Array,
        },

        canModifyJob: {
            default: false,
            required: false,
            type: Boolean,
        },

        completed: {
            default: null,
            required: false,
            type: [Boolean, null],
        },
    },

    computed: {
        ...mapGetters('jobs/single', {
            job: 'getSingleJob',
        }),

        hasRequirements() {
            return this.experience.length > 0;
        },
    },

    methods: {
        edit() {
            this.$emit('open-draft', 2, '#experience');
        },
    },
};
